import { jsx } from "panel";
import { ControlBarEl } from "common/widgets/control-bar";
import { ButtonEl } from "../button";
import { ButtonTheme } from "../button/constants";
import { ClampedTextEl } from "../clamped-text";
import { TagEl } from "../tag";
import { TagSize } from "../tag/types";
export function template() {
  const HeaderTitle = (cmp) => {
    const canEdit = cmp.attr(`can-edit`);
    const description = cmp.attr(`description`);
    const tags = cmp.attr(`tags`);
    return /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-title"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-title-text",
      attrs: {
        elref: `headerTitleButton`,
        title: cmp.attr(`title`)
      },
      class: {
        editable: canEdit
      },
      on: {
        click: canEdit && cmp.helpers.handleEditClick
      }
    }, cmp.attr(`title`), canEdit ? /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        icon: `edit`,
        theme: ButtonTheme.Tertiary,
        elref: `headerEditButton`
      },
      on: {
        click: cmp.helpers.handleEditClick
      }
    }) : null), /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-title-subtext"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-title-subtext-description-container"
    }, tags && tags.map((tag) => {
      return /* @__PURE__ */ jsx("div", {
        sel: ".mp-header-tag"
      }, /* @__PURE__ */ jsx(TagEl, {
        attrs: {
          elref: `headerTag`,
          clickable: false,
          "tag-name": tag[`tag-name`],
          size: TagSize.Small
        }
      }));
    }), description ? /* @__PURE__ */ jsx(ClampedTextEl, {
      elref: "headerDescription",
      attrs: { text: description }
    }) : null), /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-metadata"
    }, /* @__PURE__ */ jsx("slot", {
      attrs: { name: `metadataSlot` }
    }))));
  };
  const HeaderActions = (cmp) => {
    const controlBarActions = /* @__PURE__ */ jsx(ControlBarEl, {
      attrs: {
        theme: ButtonTheme.Tertiary,
        controls: { items: cmp.attr(`actions`) || [] },
        "overflow-menu-width": 210
      },
      params: {
        overflowControls: cmp.attr(`overflow-actions`) || []
      },
      on: {
        select: cmp.helpers.handleActionClick
      },
      props: { sectionsFn: () => cmp.attr(`overflow-actions`) || [] }
    }, cmp.helpers.getHeaderActionItemsSlots().map((item) => /* @__PURE__ */ jsx("slot", {
      attrs: { name: item.slot, slot: item.slot }
    })));
    return /* @__PURE__ */ jsx("div", {
      sel: ".mp-header-actions"
    }, controlBarActions);
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-header"
  }, HeaderTitle(this), HeaderActions(this));
}
